import { DialogContent } from 'components/dialogs/DialogContent';
import { styled } from 'libs/ui/styled';

export const ContainerStyled = styled(DialogContent)(() => ({
  '.confirmDialog-subtitle': {
    whiteSpace: 'pre-line',
  },
}));
